module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Murder Make$ The World Go Round")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#prologue"
    }
  }, [_vm._v("Prologue")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#part-one"
    }
  }, [_vm._v("Part One")]), _vm._v(" "), _c('ol', [_c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#the-barman"
    }
  }, [_vm._v("The Barman")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#the-platinum-card"
    }
  }, [_vm._v("The Platinum Card")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#zena-and-raindrop-sparks"
    }
  }, [_vm._v("Zena and Raindrop Sparks")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch010#a-porn-scandal"
    }
  }, [_vm._v("A Porn Scandal")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch011#the-art-squad"
    }
  }, [_vm._v("The Art Squad")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch012#the-team-meets"
    }
  }, [_vm._v("The Team Meets")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#the-new-year",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The New Year")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#weekend-in-the-country",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Weekend in the Country")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#working-out-where-to-look",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Working Out Where to Look")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#the-database",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Database")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#the-louvre",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Louvre")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#the-dinner",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dinner")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#spot",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spot")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#the-business-development-meeting",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Business Development Meeting")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#riccardo-and-kerem",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Riccardo and Kerem")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#thirteen-collections",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thirteen Collections")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#new-image",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New Image")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#confronting-woody",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Confronting Woody")])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#a-chance-meeting",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Chance Meeting")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#part-two",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two")]), _vm._v(" "), _c('ol', [_c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#tectonic-plates",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tectonic Plates")])]), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#piranha-bar",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Piranha Bar")])]), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#sightseeing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sightseeing")])]), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#key-lime-pie",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Key Lime Pie")])]), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#the-cartoonist",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Cartoonist")])]), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#the-park-ranger",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Park Ranger")])]), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#the-layover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Layover")])]), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#just-a-coffee",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Just a Coffee")])]), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#monika",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monika")])]), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#the-chakras",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Chakras")])]), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#the-zoo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Zoo")])]), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#the-new-advisor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The New Advisor")])]), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch039#just-life",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Just Life")])]), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#the-outfits",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Outfits")])]), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch041#soul-mates",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soul Mates")])]), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch042#the-actress",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Actress")])]), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch043#the-wedding",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Wedding")])]), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch044#on-to-asia",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On to Asia")])]), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch045#tea",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tea")])]), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch046#the-forbidden-city",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Forbidden City")])]), _c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch047#bits-and-bobs",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bits and Bobs")])]), _c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch048#spanish-not-chinese",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spanish, Not Chinese")])]), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#english-pub",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("English Pub")])]), _c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch050#pingle",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pingle")])]), _c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch051#dot-to-dot",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dot to Dot")])]), _c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch052#bedroom-window",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bedroom Window")])]), _c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch053#the-gateway-to-india",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Gateway to India")])]), _c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch054#the-aquarium",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Aquarium")])]), _c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch055#tiktok",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TikTok")])]), _c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch056#the-opening-event",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Opening Event")])]), _c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch057#the-private-view",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Private View")])]), _c('li', {
    attrs: {
      "id": "toc-li-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch058#the-chocolates",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Chocolates")])]), _c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch059#the-hard-rock-cafe",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hard Rock Cafe")])]), _c('li', {
    attrs: {
      "id": "toc-li-60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch060#the-discovery",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Discovery")])]), _c('li', {
    attrs: {
      "id": "toc-li-61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch061#tears",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tears")])]), _c('li', {
    attrs: {
      "id": "toc-li-62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch062#phones-4-u-n-us",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Phones 4 U N Us")])]), _c('li', {
    attrs: {
      "id": "toc-li-63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch063#biblical-scenes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Biblical Scenes")])]), _c('li', {
    attrs: {
      "id": "toc-li-64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch064#it-rains",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("It Rains")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch065#part-three",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three")]), _vm._v(" "), _c('ol', [_c('li', {
    attrs: {
      "id": "toc-li-66"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch066#return-to-london",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Return to London")])]), _c('li', {
    attrs: {
      "id": "toc-li-67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch067#back-in-the-office",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Back in the Office")])]), _c('li', {
    attrs: {
      "id": "toc-li-68"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch068#the-coroners-report",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Coroner’s Report")])]), _c('li', {
    attrs: {
      "id": "toc-li-69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch069#regroup-in-the-country",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Regroup in the Country")])]), _c('li', {
    attrs: {
      "id": "toc-li-70"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch070#visit-to-zurich",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Visit to Zurich")])]), _c('li', {
    attrs: {
      "id": "toc-li-71"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch071#police-interview",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Police Interview")])]), _c('li', {
    attrs: {
      "id": "toc-li-72"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch072#the-little-black-book",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Little Black Book")])]), _c('li', {
    attrs: {
      "id": "toc-li-73"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch073#the-reckoning",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Reckoning")])]), _c('li', {
    attrs: {
      "id": "toc-li-74"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch074#you-all-work-for-me-now",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You All Work for Me Now")])]), _c('li', {
    attrs: {
      "id": "toc-li-75"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch075#dinner-in-chelsea",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dinner in Chelsea")])]), _c('li', {
    attrs: {
      "id": "toc-li-76"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch076#the-informant",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Informant")])]), _c('li', {
    attrs: {
      "id": "toc-li-77"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch077#the-arrests",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Arrests")])]), _c('li', {
    attrs: {
      "id": "toc-li-78"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch078#the-old-bailey",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Old Bailey")])]), _c('li', {
    attrs: {
      "id": "toc-li-79"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch079#life-goes-on",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Life Goes On")])]), _c('li', {
    attrs: {
      "id": "toc-li-80"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch080#it-was-me",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("It Was Me")])]), _c('li', {
    attrs: {
      "id": "toc-li-81"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch081#the-password",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Password")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c6ea71c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0